// extracted by mini-css-extract-plugin
module.exports = {"tabSet":"jut__TabSet__tabSet","divider":"jut__TabSet__divider","frame":"jut__TabSet__frame","content":"jut__TabSet__content"};